module.exports = __webpack_public_path__ + "img/print.642214a1.png";